import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

export interface StatsCardProps {
  title: string;
  value: number | string;
  color: string;
  icon: string;
}

export const StatsCard: React.FC<StatsCardProps> = ({ 
  title, 
  value, 
  color, 
  icon 
}) => {
  return (
    <View style={[styles.statsCard, { backgroundColor: color + '15', borderColor: color }]}>
      <View style={styles.statsCardHeader}>
        <View style={[styles.statsCardIcon, { backgroundColor: color }]}>
          <Text style={styles.statsCardIconText}>{icon}</Text>
        </View>
        <Text style={styles.statsCardTitle}>{title}</Text>
      </View>
      <Text style={styles.statsCardValue}>{value}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  statsCard: {
    flex: 1,
    borderRadius: 16,
    padding: 16,
    borderWidth: 1,
  },
  statsCardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  statsCardIcon: {
    width: 28,
    height: 28,
    borderRadius: 14,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
  },
  statsCardIconText: {
    fontSize: 14,
    color: 'white',
    fontWeight: '600',
  },
  statsCardTitle: {
    fontSize: 14,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT_SECONDARY,
  },
  statsCardValue: {
    fontSize: 28,
    fontWeight: '700',
    color: ADMIN_COLORS.TEXT_PRIMARY,
  },
});
